import FUSEJS from 'fuse.js'
import { isUndefined } from 'lodash'
import store from '@/store'
export const fuseFilter = (search = '', searchableOptions = [], config = {}) => {
  const defaultConfig = {
    keys: [],
    shouldSort: true,
    threshold: 0.1
  }

  const fuse = new FUSEJS(
    searchableOptions,
    Object.assign(defaultConfig, config)
  )

  if (search && String(search).length >= 1) {
    return fuse.search(search).map(
      ({ item }) => item
    )
  }

  return searchableOptions
}

export const nullOrUndefined = value => {
  return isUndefined(value)
}

export const isNotAuthorized = (forTable = false) => {
  const user = store.getters['auth/user']
  if (user?.id) {
    return null
  }

  if (forTable) {
    return {
      data: {
        items: [],
        total_rows: 0
      }
    }
  }

  return {
    data: []
  }
}
